import * as XLSX from 'xlsx';

export const buildInventorySalesExportSheet = (items = [], stores = []) => {
  const firstHeader = ['Ngành hàng', 'Mã hàng', 'Tên hàng', 'Thương hiệu', 'Đơn vị tính'];
  const productColumnCount = firstHeader.length;
  const secondHeader = Array(productColumnCount).fill('');
  stores.forEach((store) => {
    firstHeader.push(store.storecode || store.storename, '');
    secondHeader.push('Tồn cuối kỳ', 'Xuất bán');
  });
  firstHeader.push('TỔNG TỒN', 'TỔNG BÁN');
  secondHeader.push('', '');

  const rows = items.map((item) => {
    const row = [item.categoryname, item.productcode, item.productname, item.manufacturername || '', item.unitname];
    stores.forEach((store) => {
      const cell = item.stores?.[`${store.storeid}`] || {};
      row.push(Number(cell.closing_inventory) || 0, Number(cell.sold_quantity) || 0);
    });
    row.push(Number(item.closinginventory) || 0, Number(item.soldquantity) || 0);
    return row;
  });

  const worksheet = XLSX.utils.aoa_to_sheet([firstHeader, secondHeader, ...rows]);
  worksheet['!merges'] = [
    ...Array.from({ length: productColumnCount }, (_, column) => ({ s: { r: 0, c: column }, e: { r: 1, c: column } })),
    ...stores.map((store, index) => ({
      s: { r: 0, c: productColumnCount + index * 2 },
      e: { r: 0, c: productColumnCount + 1 + index * 2 },
    })),
    { s: { r: 0, c: productColumnCount + stores.length * 2 }, e: { r: 1, c: productColumnCount + stores.length * 2 } },
    { s: { r: 0, c: productColumnCount + 1 + stores.length * 2 }, e: { r: 1, c: productColumnCount + 1 + stores.length * 2 } },
  ];
  worksheet['!cols'] = [
    { wch: 34 }, { wch: 18 }, { wch: 42 }, { wch: 20 }, { wch: 14 },
    ...stores.flatMap(() => [{ wch: 14 }, { wch: 14 }]),
    { wch: 14 }, { wch: 14 },
  ];
  return worksheet;
};
